import { useState, type ReactNode, type FormEvent } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

export function ResetPasswordPage(): ReactNode {
  const { token } = useAuth();
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [saving, setSaving] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (password !== confirm) { setError(t('auth.reset.mismatch')); return; }
    setSaving(true);
    try {
      await apiRequest('/v1/auth/reset-password', { token, method: 'POST', body: { newPassword: password } });
      setSuccess(true);
    } catch (err) { setError((err as Error).message); setSaving(false); }
  };

  if (success) return <main aria-label="reset-success"><h1>{t('auth.reset.successTitle')}</h1><p>{t('auth.reset.successBody')}</p></main>;
  return (
    <main aria-label="reset-password">
      <h1>{t('auth.reset.title')}</h1>
      {error && <p role="alert">{error}</p>}
      <form onSubmit={onSubmit} aria-label="reset-form">
        <label>{t('auth.reset.newPassword')} <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} /></label>
        <label>{t('auth.reset.confirm')} <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></label>
        <button type="submit" disabled={saving}>{saving ? t('auth.reset.saving') : t('auth.reset.reset')}</button>
      </form>
    </main>
  );
}
